module.exports = __webpack_public_path__ + "static/media/blumen.b199aba1.png";